import * as React from "react";

import "./Footer.scss";

export default class Footer extends React.Component {
    public render() {
        return (
            <div className="footer" role="contentinfo">
                <div className="footer-text-container">
                    <a className="footer-text" href="https://privacy.microsoft.com/en-us/PrivacyStatement">
                        Privacy
                    </a>
                    <a className="footer-text" href="https://www.microsoft.com/en-us/legal/terms-of-use">
                        Terms of use
                    </a>                    
                    <a className="footer-text" href="https://www.microsoft.com/en-us/legal/intellectualproperty/Trademarks/">
                        Trademarks
                    </a>
                    <div className="footer-text">© Microsoft { new Date().getFullYear() }</div>
                </div>
            </div>
        );
    }
}
